import { IonPopover } from '@ionic/react'
import React from 'react'
import './Popup.component.css'

interface IPopupProps {
  id?: string
  dataTestId: string
  isOpen: boolean
  handleHidePopover?: () => void
  className?: string
  children: React.ReactNode
  event?: any
  backdropDismiss?: boolean
}

const PopupComponent: React.FC<IPopupProps> = (props: IPopupProps) => {
  const {
    id = 'popup-container',
    dataTestId,
    isOpen,
    handleHidePopover,
    className = '',
    children,
    event,
    backdropDismiss = true,
  } = props

  return (
    <IonPopover
      id={id}
      data-testid={dataTestId ? dataTestId : 'common-popup-container'}
      showBackdrop={isOpen}
      isOpen={isOpen}
      backdropDismiss={backdropDismiss}
      onDidDismiss={handleHidePopover}
      className={className}
      event={event}>
      {children}
    </IonPopover>
  )
}

export default PopupComponent
